import React, {useState} from 'react'
import _ from '/home/ps/root'
import vw from '/home/ps/view/view'
import OctagonStar from '../../../graphic/OctagonStar'
import Slide from '../slide'
import View from '../../view'
import './logo.css'
// import { hot } from 'react-hot-loader'
export const ID = 'logo'
const Logo = prop => {
  const {connected} = prop.master
  const p = prop.prop(ID)
  p.onClick = e => prop.slide(ID)
  // p.style = {fill: prop.master.connected ? vw.COLOR_THEME : vw.COLOR_RED}
  const h = vw.HEIGHT
  const small = h
  const big = h*3/2
  // const bigger = h*2
  // p.fill = vw.COLOR_THEME
  p.fill = connected ? vw.COLOR_RED : vw.COLOR_THEME
  // p.fill = connected ? vw.COLOR_THEME : vw.COLOR_RED
  // p.fill = connected ? vw.COLOR_RED : vw.COLOR_THEME
  // p.width = connected ? big : small
  // p.height = connected ? big : small
  p.width = small
  p.height = small
  // p.viewBox = connected ? `0 0 ${big} ${big}` : `0 0 ${small} ${small}`
  // p.viewBox = connected ? `0 0 ${bigger} ${bigger}` : `0 0 ${small} ${small}`
  p.viewBox = `0 0 ${small} ${small}`
  return <OctagonStar {...p}/>
}
Logo.ID = ID
export default Logo
